import React, { Fragment } from "react";

import "./Content.css";
import "../../../styles/uikit.css";

const ContentHeader = (props) => (
  <Fragment>
    <main className="mn-content-layout">
      <div className="uk-container uk-container-large">
        <div className="mn-grid">{props.children}</div>
      </div>
    </main>
  </Fragment>
);

export default ContentHeader;
